module.exports = "//public.zight.com/packs/media/images/icons-card-actions-compact-read-only-2df23140e660d39e91444aa43e0cf994.svg";